import { FormControlLabel, Switch } from '@mui/material';
import React, { ChangeEvent, ReactElement } from 'react';

interface IProps {
  color?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'default';
  label: string;
  checked?: boolean;
  isLoading?: boolean;
  onChange: (checked: boolean, e: ChangeEvent<HTMLInputElement>) => void;
}

export function ControlledSwitch({
  color,
  label,
  isLoading,
  checked,
  onChange,
}: IProps): ReactElement {
  return (
    <FormControlLabel
      control={
        <Switch
          disabled={!!isLoading}
          checked={checked}
          onChange={(e, value) => {
            onChange(value, e);
          }}
          color={color}
        />
      }
      label={label + (isLoading ? ' ...' : '')}
    />
  );
}
